// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rXzsA","left":"styles_left__12bWk"};